import { NCALayerClient } from "ncalayer-js-client";
import { useTranslations } from "use-intl";

import { useNotification } from "@/shared/feedback/notification";

export function useSigningWithNCALayer() {
  const notify = useNotification();
  const t = useTranslations("Signing");

  async function sign(documentInBase64: string): Promise<string | undefined> {
    const ncalayerClient = new NCALayerClient();

    try {
      await ncalayerClient.connect();
    } catch {
      notify?.error({
        message: t("Failed to connect to NCALayer"),
      });
      return;
    }

    try {
      const activeTokens = await ncalayerClient.getActiveTokens();
      const storageType = activeTokens[0] || NCALayerClient.fileStorageType;
      return await ncalayerClient.createCAdESFromBase64(
        storageType,
        documentInBase64,
      );
    } catch {
      notify?.error({
        message: t("Failed to sign the document with NCALayer"),
      });
      return;
    }
  }

  return {
    sign,
  };
}
